export default "__VITE_ASSET__B0y$zPec__"